export const getters = {
    experimentGroup(state, getters, rootState, rootGetters) {
        return rootGetters['global/account']?.experimentGroup
    },
}
